import { useMemo } from 'react';

import { Box, Popover } from '@mui/material';
import { format, parse } from 'date-fns';

import FilterButton from './FilterButton';
import { useFilterAnchor } from './useFilterAnchor';

import { SingleCalendar } from '@/shared/components/dayPicker';

interface DateFilterProps {
  filterId: string;
  buttonAriaLabel: string;
  searchParamStringDate: string | undefined;
  handleNavigation: (newDate: string | undefined) => void;
}

const DateFilter = ({
  filterId,
  buttonAriaLabel,
  searchParamStringDate,
  handleNavigation,
}: DateFilterProps) => {
  const { anchorEl, handleOpen, handleClose, open, popoverId } =
    useFilterAnchor(filterId);

  const searchParamDate = useMemo(() => {
    if (!searchParamStringDate) {
      return undefined;
    }
    return parse(searchParamStringDate, 'yyyy-MM-dd', new Date());
  }, [searchParamStringDate]);

  const handleDateChange = (newDate: Date | undefined) => {
    const newDateString = newDate ? format(newDate, 'yyyy-MM-dd') : undefined;
    handleNavigation(newDateString);
  };

  return (
    <>
      <FilterButton
        isActive={!!searchParamDate}
        onClick={handleOpen}
        aria-label={buttonAriaLabel}
      />
      <Popover
        id={popoverId}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Box px={3} py={2.5}>
          <SingleCalendar
            date={searchParamDate}
            handleSetDate={handleDateChange}
            handleClose={handleClose}
            calenderProps={{
              defaultMonth: searchParamDate,
            }}
          />
        </Box>
      </Popover>
    </>
  );
};

export default DateFilter;
